import { render, staticRenderFns } from "./decorate.vue?vue&type=template&id=a1a3f556&scoped=true&"
import script from "./decorate.vue?vue&type=script&lang=ts&"
export * from "./decorate.vue?vue&type=script&lang=ts&"
import style0 from "./decorate.vue?vue&type=style&index=0&id=a1a3f556&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/registry.npmmirror.com+vue-loader@15.9.8_m6jvttnwtqqy6l4pi5vsxiehsy/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1a3f556",
  null
  
)

export default component.exports